import Image from "next/image";

import Logo from "@/assets/img/KMV_Logo_RGB_AzulTagline.png";
import bulletPink from "@/assets/img/security/bullet_pink.svg";
import graph from "@/assets/img/security/mask-cover.svg";
import { Container } from "@/components/Container";
import richTextRendererUtils from "@/utils/richTextRenderer";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { Document } from "@contentful/rich-text-types";
import { Box, Stack, Typography } from "@mui/material";

import { styles } from "./styles";
import { SecurityCoverProps } from "./types";

export const SecurityCover: React.FC<SecurityCoverProps> = ({ bannerCard, adviceText }) => {
  return (
    <>
      <Stack bgcolor="#FFC800" flexDirection="row" position="relative">
        <Box minWidth="35rem" minHeight="30rem" position="relative" display={{ xs: "none", md: "inherit" }}>
          <Box minWidth="100%" position="relative" display={{ xs: "none", md: "inherit" }}>
            <Box
              component="img"
              src={bannerCard?.image}
              alt=""
              position="absolute"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderBottom: "3px solid #0045B5"
              }}
            />

            <Box
              style={{
                width: "auto",
                height: "100%",
                right: 0,
                position: "absolute"
              }}
            >
              <Image
                src={graph}
                alt=""
                style={{
                  width: "auto",
                  height: "100%",
                  objectFit: "cover"
                }}
              />
              <Image src={bulletPink} alt="" style={{ width: 32, height: 32, position: "absolute", left: -15, bottom: -14 }} />
            </Box>
          </Box>
        </Box>

        <Container bgcolor="#FFC800" pt={{ xs: 6, md: 3 }} pb={8} px={{ xs: "24px", sm: "24px", md: "0px", lg: "0px" }} alignSelf="center">
          <Stack mr={{ sm: 3, lg: 10 }} spacing={3} display="flex" alignSelf="start" justifyContent="start">
            <Image src={Logo} alt="KMV" width={180} height={90} css={styles.imag_logo} />

            <Typography fontWeight={600} fontSize={32} color="#0045B5" pt={{ xs: 3, sm: 3, md: 1 }}>
              {bannerCard?.title}
            </Typography>

            <Typography
              component="span"
              fontSize={16}
              maxWidth={{ lg: 700, xl: "none" }}
              whiteSpace="pre-line"
              style={{ wordBreak: "break-word" }}
              css={styles.typography__description}
            >
              {documentToReactComponents(bannerCard?.description as Document)}
            </Typography>
          </Stack>
        </Container>
      </Stack>

      <Container pt={{ xs: 6, sm: 6, md: 10 }} px={{ xs: "24px", sm: "24px", md: "84px", lg: "81px" }}>
        <Typography component="span" color="#0045B5" css={styles.typography__description}>
          {documentToReactComponents(adviceText as Document, richTextRendererUtils)}
        </Typography>
      </Container>
    </>
  );
};
